import { render } from "./OkrElementsList.vue?vue&type=template&id=1233a754&scoped=true"
import script from "./OkrElementsList.vue?vue&type=script&lang=js"
export * from "./OkrElementsList.vue?vue&type=script&lang=js"

import "./OkrElementsList.vue?vue&type=style&index=0&id=1233a754&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1233a754"]])

export default __exports__